// export const getUrlSearchValue = (key: string): string => {
//   const url = new URL(window.location.href);
//   return url.searchParams.get(key) as string;
// };

export const getUrlSearchValue = (key: string): string => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get(key) || '';
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const handleSampleDownload = (linkURL: string, selectedType: string) => {
  // Create a new <a> element
  const link = document.createElement('a');
  link.href = linkURL; // Specify the file URL here
  link.download = `sample.${selectedType}`; // Specify the file name here
  // Simulate a click on the <a> element to start the download
  link.click();
};
